<template>
    <div
        v-if="show_estimation"
        class="mr-3 fields-flow-item"
    >
        <v-menu
            :value="estimationsMenu"
            offset-y
            nudge-top="16"
            @input="updateMenuState"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="formData.estimation_f"
                    outlined
                    class="task-form-elem"
                    :label="$t('Estimation')"
                    :error-messages="formData.estimation_error"
                    v-on="on"
                    @change="time_field_changed('estimation', $event)"
                ></v-text-field>
            </template>
            <v-list dense>
                <v-list-item
                    v-for="(item, index) in estimations_list"
                    :key="index"
                    @click="estimation_select(item.value)"
                >
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-regular subtitle-2">
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon
                            v-if="taskData.estimation === item.value"
                            color="primary"
                        >
                            check
                        </v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { $t } from "@/i18n";

export default {
    name: "TaskEstimation",
    props: {
        formData: {
            type: Object,
            default: () => null
        },
        taskData: {
            type: Object,
            default: () => null
        },
        estimationsMenu: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const estimations_list = ref([
            { value: 60, name: $t("1 min") },
            { value: 300, name: $t("5 min") },
            { value: 600, name: $t("10 min") },
            { value: 1800, name: $t("30 min") },
            { value: 3600, name: $t("1 h") }
        ]);

        const show_estimation = computed(function () {
            return props.formData.estimation_show || props.taskData.estimation != null;
        });

        const updateMenuState = function () {
            ctx.emit('updateMenuState');
        }

        const time_field_changed = function (field_name, data) {
            ctx.emit("time_field_changed", field_name, data);
        }

        const estimation_select = function (seconds) {
            ctx.emit("estimation_select", seconds)
        }

        return {
            show_estimation,
            updateMenuState,
            time_field_changed,
            estimation_select,
            estimations_list
        }
    }
}
</script>
